﻿/* 
Object:         Navigation Bar (this is only active in the mobile view)
Description:    Handlers the actions that are availible when the user clicks on one of the buttons in the navigation bar.
Used in:        Mobile View only
*/

window.selection_navigation_bar = function () {

    return {
        /**
         * Set event handlers for the navigation bar.
         */
        initialize: function () {

            $("#gotoCurrentNode").click(function () {
                navigation.navigateToCurrentNode();
            });

            $("#gotoCurrentModule").click(function () {
                navigation.navigateToCurrentModule();
            });
        }
    }

}();